import IcEdit from 'assets/Icons/IcEdit';
import TrashV2 from 'assets/Icons/trashV2';
import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import colorTheme from 'constants/color';
import { IPackageProgram } from 'features/settingService/services/types/packageSetting';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import RequestAdminPWCallback, {
  useRequestAdminPWCallbackRef,
} from 'widgets/RequestAdminLocalPW/Callback';

interface DetailHeaderProps {
  data: IPackageProgram | null;
  onEditPackage: () => void;
  onDeletePackage: (id: string) => void;
}
const DetailHeader = ({
  data,
  onEditPackage,
  onDeletePackage,
}: DetailHeaderProps) => {
  const pwRef = useRequestAdminPWCallbackRef();

  const handleDeletePackage = () => {
    if (!data) return;
    pwRef.current?.open(() => onDeletePackage(data.id));
  };
  
  return (
    <HeaderContainer>
      <div className='header-left'>
        <Text variant='H1' className='header-title'>
          {data?.name}
        </Text>
        <Text variant='H8' className='header-description' color='text_3_v2'>
          {data?.description}
        </Text>
      </div>
      <div className='header-center'>
        <Text variant='H8' className='text-medium'>
          Regular price
        </Text>
        <Box display='flex' alignItems='center' gap='1'>
          <Text variant='H6' className='header-price' color='v2_green_7'>
            {formatCurrency(data?.price || 0)}
          </Text>
          <Text variant='H8' className='text-medium'>
            /session
          </Text>
        </Box>
      </div>
      <div className='header-right'>
        <Button
          ntype='NEW_TYPE'
          iconElement={
            <IcEdit fill={colorTheme.v2_secondary_3} width={28} height={28} />
          }
          onClick={onEditPackage}
        >
          Edit Package
        </Button>
        <Button
          ntype='DANGER'
          cardCashier
          iconElement={<TrashV2 fill={colorTheme.v2_primary_bg_6} />}
          onClick={handleDeletePackage}
        >
          Delete Package
        </Button>
      </div>
      <RequestAdminPWCallback v2 ref={pwRef} onlyAdmin />
    </HeaderContainer>
  );
};

export default DetailHeader;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  font-family: Poppins;
  margin-right: 16px;

  .text-medium {
    font-weight: 500;
  }

  .header-left {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .header-title {
      font-size: 40px;
      font-weight: 600;
    }

    .header-description {
      font-weight: 500;
    }
  }

  .header-center {
    display: flex;
    flex-direction: column;
    align-items: start;
    border-left: 4px solid ${colorTheme.v2_green_7};
    background: linear-gradient(90deg, #effffa 0%, #fff 100%);
    padding: 8px 24px;

    .header-price {
      font-size: 40px;
      font-weight: bold;
    }
  }

  .header-right {
    display: flex;
    gap: 16px;

    .ant-btn {
      padding: 0 24px;
    }

    .CONTENT_2 {
      font-size: 20px;
      font-family: Poppins;
    }

    .DANGER {
      .color {
        color: ${colorTheme.v2_primary_bg_6};
      }
    }
  }
`;
